(function () {
  if (window.ectEasifySwatchLightboxLoaded) return;
  window.ectEasifySwatchLightboxLoaded = true;

  var selectors = [
    '.tpo_image-swatch-img',
    '.tpo-image-swatch-img',
    '.tpo_option-set img',
    '.tpo_option-wrapper img'
  ];

  function getSwatchImages() {
    return Array.prototype.slice.call(document.querySelectorAll(selectors.join(','))).filter(function (img) {
      if (!img || !img.src) return false;
      if (img.closest('.product-lightbox, .ect-swatch-lightbox')) return false;
      var rect = img.getBoundingClientRect();
      return rect.width >= 24 && rect.height >= 24;
    });
  }

  function getLargeImageUrl(img) {
    var src = img.currentSrc || img.src;

    src = src.replace(/_(\d+)x(\d+)?(?=\.)/i, '');
    src = src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.)/i, '');

    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.delete('width');
      url.searchParams.delete('height');
      url.searchParams.delete('crop');
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function ensureLightbox() {
    var existing = document.querySelector('.ect-swatch-lightbox');
    if (existing) return existing;

    var style = document.createElement('style');
    style.textContent = [
      '.ect-swatch-lightbox{position:fixed;inset:0;z-index:1000000;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.9);}',
      '.ect-swatch-lightbox.is-active{display:flex;}',
      '.ect-swatch-lightbox__img{display:block;max-width:min(92vw,1200px);max-height:86vh;object-fit:contain;cursor:zoom-out;}',
      '.ect-swatch-lightbox__btn{position:absolute;z-index:2;display:flex;align-items:center;justify-content:center;width:44px;height:44px;border:1px solid rgba(255,255,255,.25);border-radius:999px;background:rgba(255,255,255,.94);color:#111;font-size:28px;line-height:1;cursor:pointer;}',
      '.ect-swatch-lightbox__close{top:18px;right:18px;}',
      '.ect-swatch-lightbox__prev{left:22px;}',
      '.ect-swatch-lightbox__next{right:22px;}',
      '.ect-swatch-lightbox__counter{position:absolute;right:22px;bottom:18px;padding:8px 13px;border-radius:999px;background:rgba(255,255,255,.94);color:#111;font-size:13px;}',
      'body.ect-swatch-lightbox-open{overflow:hidden;}',
      '@media(max-width:768px){.ect-swatch-lightbox__btn{width:40px;height:40px}.ect-swatch-lightbox__prev{left:10px}.ect-swatch-lightbox__next{right:10px}.ect-swatch-lightbox__close{top:10px;right:10px}}'
    ].join('');
    document.head.appendChild(style);

    var lightbox = document.createElement('div');
    lightbox.className = 'ect-swatch-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.innerHTML = [
      '<button type="button" class="ect-swatch-lightbox__btn ect-swatch-lightbox__close" aria-label="Close">&times;</button>',
      '<button type="button" class="ect-swatch-lightbox__btn ect-swatch-lightbox__prev" aria-label="Previous image">&#8249;</button>',
      '<img class="ect-swatch-lightbox__img" alt="">',
      '<button type="button" class="ect-swatch-lightbox__btn ect-swatch-lightbox__next" aria-label="Next image">&#8250;</button>',
      '<div class="ect-swatch-lightbox__counter" aria-live="polite"></div>'
    ].join('');
    document.body.appendChild(lightbox);
    return lightbox;
  }

  var currentIndex = 0;
  var currentImages = [];

  function show(index) {
    var lightbox = ensureLightbox();
    var img = lightbox.querySelector('.ect-swatch-lightbox__img');
    var counter = lightbox.querySelector('.ect-swatch-lightbox__counter');

    if (!currentImages.length) return;
    currentIndex = (index + currentImages.length) % currentImages.length;

    var swatch = currentImages[currentIndex];
    img.src = getLargeImageUrl(swatch);
    img.alt = swatch.alt || '';
    counter.textContent = (currentIndex + 1) + ' / ' + currentImages.length;
  }

  function openFrom(target) {
    currentImages = getSwatchImages();
    currentIndex = currentImages.indexOf(target);
    if (currentIndex < 0) return;

    var lightbox = ensureLightbox();
    show(currentIndex);
    lightbox.classList.add('is-active');
    document.body.classList.add('ect-swatch-lightbox-open');
  }

  function close() {
    var lightbox = document.querySelector('.ect-swatch-lightbox');
    if (!lightbox) return;
    lightbox.classList.remove('is-active');
    document.body.classList.remove('ect-swatch-lightbox-open');
  }

  document.addEventListener('click', function (event) {
    var lightbox = event.target.closest('.ect-swatch-lightbox');
    if (lightbox) {
      if (event.target.matches('.ect-swatch-lightbox__close') || event.target.matches('.ect-swatch-lightbox__img') || event.target === lightbox) {
        close();
      } else if (event.target.closest('.ect-swatch-lightbox__prev')) {
        show(currentIndex - 1);
      } else if (event.target.closest('.ect-swatch-lightbox__next')) {
        show(currentIndex + 1);
      }
      return;
    }

    var swatchImg = event.target.closest(selectors.join(','));
    if (!swatchImg) return;

    window.setTimeout(function () {
      openFrom(swatchImg);
    }, 0);
  });

  document.addEventListener('keydown', function (event) {
    var lightbox = document.querySelector('.ect-swatch-lightbox.is-active');
    if (!lightbox) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') show(currentIndex - 1);
    if (event.key === 'ArrowRight') show(currentIndex + 1);
  });
})();
